



























































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {
	mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';

import LoginModal from '@/components/LoginModal.vue';
import LookupModal from '@/components/lookup/LookupModal.vue';
import ReservationConfirmation from '@/components/ReservationConfirmation.vue';
import ReservationCustomerDetails from '@/components/ReservationCustomerDetails.vue';
import ReservationPayment from '@/components/ReservationPayment.vue';
import ReservationQuoteDetails from '@/components/ReservationQuoteDetails.vue';
import ReservationQuoteList from '@/components/ReservationQuoteList.vue';
import ReservationServices from '@/components/ReservationServices.vue';
import ReservationStep from '@/components/ReservationStep.vue';
import MarkdownText from '@/components/ui/MarkdownText.vue';
import ReservationSummary from '@/components/ReservationSummary.vue';
import SectionLoader from '@/components/SectionLoader.vue';
import TransitionExpand from '@/components/TransitionExpand.vue';
import Customer from '@/models/Customer';
import Quote from '@/models/Quote';
import Service from '@/models/Service';
import Reservation from '@/models/Reservation';
import Step from '@/types/reservationStep';

const Setup = Vue.extend({
	name: 'ReservationSteps',
	components: {
		LoginModal,
		MarkdownText,
		ReservationConfirmation,
		ReservationQuoteList,
		ReservationCustomerDetails,
		ReservationQuoteDetails,
		ReservationPayment,
		ReservationServices,
		ReservationStep,
		ReservationSummary,
		SectionLoader,
		TransitionExpand,
		LookupModal,
	},
	computed: {
		...mapGetters(['customer', 'locationsMap']),
		...mapState('reservation', { isEdit: 'edit' }),
		...mapState('reservation', ['availableServices', 'options', 'quotes', 'reservation', 'selectedQuote', 'step']),
		...mapGetters('reservation', ['hasQuote', 'hasServices', 'noServicesOnRate', 'services']),
		...mapGetters('location', ['settings']),
	},
	methods: {
		...mapMutations('reservation', ['clearQuote', 'setStep']),
		...mapActions('reservation', ['getQuotes']),

		handleBeforeUnload(event: BeforeUnloadEvent) {
			// Cancel the event
			event.preventDefault();
			// Chrome requires returnValue to be set
			event.returnValue = ''; // Display a generic message here if needed
		},
	},
	watch: {
		step(value: Step) {
			if (value === Step.Confirmation) {
				window.removeEventListener('beforeunload', this.handleBeforeUnload);
			} else if (value <= Step.Customer) {
				window.addEventListener('beforeunload', this.handleBeforeUnload);
			}
		},
	},
});

@Component
class ReservationSteps extends Setup {
	// Data
	public Step = Step;
	public quoteChanged = false;

	// Vuex
	public options!: any;
	public selectedQuote!: Quote;
	public availableServices!: Service[];
	public customer!: Customer;
	public locationsMap!: any;
	public hasQuote!: boolean;
	public hasServices!: boolean;
	public services!: Service[];
	public settings!: Locations.Settings;
	public noServicesOnRate!: boolean;
	public clearQuote!: () => void;
	public quotes!: Quote[];
	public reservation!: Reservation;
	public step!: Step;

	public get showLoginModal(): boolean {
		return this.step === Step.Quotes && !this.customerOfDifferentLocation && !this.settings.hide_login_after_quote;
	}

	public get showLookupModal(): boolean {
		return this.step === Step.Quotes && !this.settings.disable_reservation_lookup;
	}

	public get customerOfDifferentLocation(): boolean {
		const cust_location = (this.customer.code || '').toString();

		const loc = `${this.reservation.location_code}-${this.reservation.location}`;
		const location = this.locationsMap[loc];

		return !!this.customer.customer && location && location.custLocation.toString() !== cust_location;
	}

	public async skipServicesSelect() {
		console.log('No Services Selected...');
		this.uxAction();

		try {
			await this.getQuotes();
			// if (this.requiresPayment) {
			this.setStep(Step.Payment);
			// } else {
			//	this.setStep(Step.Summary);
			// }
		} catch (errors) {
			// Error
		}
	}

	public get quoteTitle(): string {
		if (this.quotes.length && !this.hasQuote) {
			return 'Select a Quote';
		}

		if (this.hasQuote) {
			return 'Quote Details';
		}

		return 'Quote';
	}

	public get requiresPayment(): boolean {
		return this.reservation.quote.is_prepay && this.reservation.quote.prepay_amount > 0;
	}

	public async edit(step: Step) {
		switch (step) {
			case Step.Quotes:
				this.clearQuote();
				await this.getQuotes();
				this.quoteChanged = true;
				break;
			case Step.Customer:
			case Step.Services:
			case Step.Payment:
			default:
				break;
		}
		const stepAsString = Object.keys(Step)[Object.values(Step).indexOf(step)];

		this.$store.dispatch('googleEvents/reservationEditButtonClick', {
			edit: stepAsString,
		});

		this.setStep(step);
	}

	public uxAction() {
		this.$store.dispatch('googleEvents/clickFinalizeServiceChanges', {
			services: [],
		});

		this.$store.dispatch('analytics/action', {
			type: 'UX',
			label: 'click',
			value: 'Reservation Services',
			step: this.$store.state.reservation.step,
		} as Analytics.ActionParams);
	}
}

export default ReservationSteps;
